import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _StimulusItemsBase;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx } from '@instructure/emotion';
import { makeScrollable } from '@instructure/quiz-core';
import TakeItem from '../../TakeItem';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
var StimulusItemsBase = /*#__PURE__*/function (_Component) {
  function StimulusItemsBase() {
    var _this2;
    _classCallCheck(this, StimulusItemsBase);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, StimulusItemsBase, [].concat(args));
    _defineProperty(_this2, "renderItem", function (sessionItem) {
      return jsx("div", {
        key: sessionItem.position,
        css: _this2.props.styles.itemWrapper
      }, jsx("div", {
        css: _this2.props.styles.linesStyles
      }), jsx("div", {
        css: _this2.props.styles.stimulusItem
      }, jsx(TakeItem, {
        quizSessionId: _this2.props.quizSessionId,
        sessionItem: sessionItem,
        scrollToInfo: _this2.props.scrollToInfo,
        lockDown: _this2.props.lockDown,
        isInStimulus: true
      })));
    });
    return _this2;
  }
  _inherits(StimulusItemsBase, _Component);
  return _createClass(StimulusItemsBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, this.props.items.toArray().map(this.renderItem));
    }
  }]);
}(Component);
_StimulusItemsBase = StimulusItemsBase;
_defineProperty(StimulusItemsBase, "displayName", 'StimulusItemsBase');
_defineProperty(StimulusItemsBase, "componentId", "Quizzes".concat(_StimulusItemsBase.displayName));
_defineProperty(StimulusItemsBase, "propTypes", {
  items: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizSessionId: PropTypes.string.isRequired,
  scrollToInfo: PropTypes.func.isRequired,
  lockDown: PropTypes.bool,
  horizontallyAligned: PropTypes.bool,
  makeStyles: PropTypes.func,
  styles: PropTypes.object
});
_defineProperty(StimulusItemsBase, "defaultProps", {
  lockDown: false,
  horizontallyAligned: true
});
export var StimulusItems = compose(makeScrollable, withStyleOverrides(generateStyle, generateComponentTheme))(StimulusItemsBase);
export default StimulusItems;